import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from './Login';
import { Register } from './Register';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      {/* <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password/:token" element={<ResetPassword />} /> */}

      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
